import foodapp from "../image/food-app.png";
import tictactoe from "../image/tictactoe.png";
import movieapp from "../image/movieapp.png";
import weather from "../image/weather.png";
import jobListing from "../image/jobListing.png";
import rickSearch from "../image/rickSearch.png";
import translation from "../image/translation.png";

export const AllProjectData =
[
    {
        id: 1,
        title: 'Food App',
        img: foodapp,
        techStack: 'React, Context API, NodeJs, Express, MongoDB',
        feature: 'Login, signUp, Products Page, Average rating and ratings count for each item, Cart',
        git: "https://github.com/Neha-251/Advanced-Mongo--Ecommerce",
        visit: 'https://advanced-mongo-food-app.vercel.app'
    },
    {
        id: 2,
        title: 'Tic Tac Toe Game',
        img: tictactoe,
        techStack: 'HTML, CSS, JavaScript',
        feature: 'Play, Know who wins, if game is tie, change theme',
        git: "https://github.com/Neha-251/Tic-Tac-Toe",
        visit: 'https://tic-tac-toe-zeta-sooty.vercel.app/'
    },
    {
        id: 3,
        title: 'Movie App',
        img: movieapp,
        techStack: 'HTML, CSS, JavaScript',
        feature: 'Search Bar similar to Hotstar website, search movie',
        git: "https://github.com/Neha-251/Movie-app",
        visit: 'https://movie-app-six-sandy.vercel.app/'
    },
    {
        id: 4,
        title: 'Weather App',
        img: weather,
        techStack: ' HTML, CSS, JavaScript',
        feature: 'Weather update with 7 days weather prediction as well as live location tracking facility',
        git: "https://github.com/Neha-251/Weather-App-with-Live-location",
        visit: 'https://dashing-paprenjak-167efb.netlify.app/'
    },
    {
        id: 5,
        title: 'Rick and Morty',
        img: rickSearch,
        techStack: 'React',
        feature: 'Search experience with debouncing and infinite scrolling',
        git: "https://github.com/Neha-251/Rick-and-Morty-Search.git",
        visit: 'https://rick-and-morty-search-sand.vercel.app/'
    },
    {
        id: 6,
        title: 'Job Listing App',
        img: jobListing,
        techStack: 'React, NodeJs, Mongoose, Express',
        feature: 'Job Listing Application with filter and pagination',
        git: "https://github.com/Neha-251/job-listing-application.git",
        visit: 'https://job-listing-application.vercel.app/'
    },
    {
        id: 7,
        title: 'Food App',
        img: foodapp,
        techStack: 'React, Context API, NodeJs, Express, MongoDB',
        feature: 'Login, signUp, Products Page, Average rating and ratings count for each item, Cart',
        git: "https://github.com/Neha-251/Translation-App.git",
        visit: 'https://translation-app-pink.vercel.app/'
    }
]